<template>
  <button
    class="btn btn-secondary editor-submit"
  >
    {{ button.content }}
  </button>
</template>
<script>
export default {
  props: {
    button: {
      type: Object,
      required: true
    }
  },
}
</script>
<style lang="sass" scoped>
.editor-submit
  border-radius: 0px
</style>



// WEBPACK FOOTER //
// DragSubmitButton.vue?0b3ff1f8